import React from 'react'
import Resx from '@/components/Resx'
import { Validator } from '@/components/validation'
import { Form, FormGroup, Input, Label } from 'reactstrap'
import { DropDownList } from '@/components/dropDownList'
import context from '@/context'
import { DatePicker } from '@/components/DatePicker'
import RichTextWithAttachment from '@/components/messages/richtext-with-attachment'
import { InfoContent } from '@/components/InfoRow'
import { useLocalization } from '@/hooks/localization'

const MessageEditorContent = function MessageEditorContent (props) {
  const { locale } = useLocalization()
  const { message, attachments, updateDto, updateAttachments, replyMessage, replyMessageAttachments, isReport, hideRecipient } = props

  return (
    <Form>
      {!hideRecipient &&
        <FormGroup>
          <Label><Resx name='Messages.Recipient' /></Label>
          {isReport
            ? <InfoContent><Resx name='Common.CBI' /></InfoContent>
            : <Validator name='recipient' value={message.institutionId} required>
              <DropDownList data-cy='RecipientDropdown'
                dataSource={context.api.institutionService.getLookup}
                onChange={({ item }) => updateDto({ institutionId: item.id, institution: item })}
                value={message && message.institutionId && {
                  id: message.institutionId,
                  [(locale === 'en' ? 'latinName' : 'name')]: (locale === 'en' ? message.institution.latinName : message.institution.name)
                }} />
            </Validator>
          }
        </FormGroup>}
      <FormGroup>
        <Label><Resx name='Messages.Subject' /></Label>
        <Validator name='subject' value={message.subject} required>
          <Input data-cy='Subject' onChange={e => updateDto({ subject: e.target.value })} name='subject' defaultValue={message.subject} />
        </Validator>
      </FormGroup>
      {!isReport &&
        <FormGroup>
          <Label><Resx name='Messages.DueDate' /></Label>
          <DatePicker data-cy='DueDate' onChange={value => updateDto({ dueDate: value })} value={message.dueDate} />
        </FormGroup>
      }
      <RichTextWithAttachment message={message}
        replyMessage={replyMessage}
        replyAttachments={replyMessageAttachments}
        attachments={attachments}
        updateAttachments={updateAttachments}
        updateDto={updateDto}
        isReply={false} />
    </Form>
  )
}

export { MessageEditorContent }



// WEBPACK FOOTER //
// ./src/components/messages/editor-content.js